/**
 * Created by yuanlei on 2019/12/10.
 */
/**
 * 接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

var apis = {
  // get请求-通用
  getData(url, params) {
    let data = {
      ...params
    }
    return axios.post(`${base.supply}` + url, JSON.stringify(data));
  },
  // 登录
  loginSupply(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.login}` + '/loginSupply?'+qs.stringify(data));
  },
  // 修改密码
  changePassword(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.supply}` + '/saveInfo?'+qs.stringify(data));
  },
  // 货主端忘记密码 - 用户名查询
  getUserByLoginname(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logisticsTool}` + '/getUserByLoginname?'+qs.stringify(data));
  },
  // 货主端忘记密码 - 用户名查询
  updatePassword(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logisticsTool}` + '/updatePassword?'+qs.stringify(data));
  },
  // 货主短信验证
  sendMobilecode(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logisticsTool}` + '/send-mobilecode?'+qs.stringify(data));
  },
  // 新增发货单 获取处理网点
  getQueryCustomerInfos(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/customer/queryCustomerInfos?'+qs.stringify(data));
  },
  // 新增发货单 获取收发货单位
  getConsigneesGetList(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/customer-senders-consignees/getList?'+qs.stringify(data));
  },
  // 新增发货单 根据收发货单位Id获取收发货地址信息
  getQuerySenconsAddrByScId(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/customer-sencons-addr/querySenconsAddrByScId?'+qs.stringify(data));
  },
  // 新增发货单 根据收发货单位Id获取收发货地址信息
  getQuerySenconsAddrById(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/customer-sencons-addr/querySenconsAddrById?'+qs.stringify(data));
  },
  // 新增发货单 获取货品信息
  getProducts(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/product/getProducts?'+qs.stringify(data));
  },
  // 新增发货单和原材料下单  获取货品计量单位
  queryProductUnits(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/product-unit/queryProductUnits?'+qs.stringify(data));
  },
  // 新增发货单
  addSupply(params) {
    let data = {
      ...params
    }
    return axios.post(`${base.logistics}` + '/supply-transport-document/addSupply',JSON.stringify(data));
  },
  // 获取发货单列表
  async supplyList(params) {
    let data = {
      ...params
    }
    return await axios.get(`${base.logistics}` + '/supply-transport-document/supplyList?'+qs.stringify(data));
  },
  // 获取发货单对应运输单列表
  async bidList(params) {
    let data = {
      ...params
    }
    return await axios.get(`${base.logistics}` + '/bid-order/bidList?'+qs.stringify(data));
  },
  // 获取发货单对应派车单列表
  async getTrafficDispatchOrderFromSupply(params) {
    let data = {
      ...params
    }
    return await axios.get(`${base.logistics}` + '/dispatch-order/getTrafficDispatchOrderFromSupply?'+qs.stringify(data));
  },
  // 获取派车单详情步进器列表
  getTransRecordDetail(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/trans-record/detail?'+qs.stringify(data));
  },
  // 原材料下单 获取收货单位信息
  getListWithRawMaterial(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/customer-senders-consignees/getListWithRawMaterial?'+qs.stringify(data));
  },
  // 原材料下单 从Erp获取货品信息
  getProductsByErp(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/product/getProductsByErp?'+qs.stringify(data));
  },
  // 原材料下单 获取发货单位信息
  getconsignerByErp(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/customer-senders-consignees/getconsignerByErp?'+qs.stringify(data));
  },
  // 原材料下单 获取发货地点信息
  getMineByErp(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/customer-sencons-addr/getMineByErp?'+qs.stringify(data));
  },
  // 新增原材料发货单
  addRawMaterial(params) {
    let data = {
      ...params
    }
    return axios.post(`${base.logistics}` + '/supply-transport-document/addRawMaterial',JSON.stringify(data));
  },
  // 获取可用余额
  getCanUserMoney(params) {
    let data = {
      ...params
    }
    return axios.post(`${base.logistics}` + '/supply/accountCreditInfo/getCanUserMoney',JSON.stringify(data));
  },
  // 获取授信记录
  async getCreditInfoList(params) {
    let data = {
      ...params
    }
    return await axios.get(`${base.logistics}` + '/supply/accountCreditInfo/getCreditInfoList?'+qs.stringify(data));
  },
  // 获取支出流水
  async getCreditInfoList2(params) {
    let data = {
      ...params
    }
    return await axios.post(`${base.logistics}` + '/supply/accountCreditInfo/getCreditInfoList2',JSON.stringify(data));
  },
  // 授信申请
  accountCreditInfoApply(params) {
    let data = {
      ...params
    }
    return axios.get(`${base.logistics}` + '/supply/accountCreditInfo/apply?'+qs.stringify(data));
  },
}

export default apis;



// WEBPACK FOOTER //
// ./src/api/api.js